import React, { useEffect, useState, useRef } from "react";

import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";

import RoomImage from "../../assets/png/room-view-image.png";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "react-day-picker/dist/style.css";
import { apiCall } from "../../services/api-service";
import office from "../../assets/png/roomoffice.png";
import qr from "../../assets/png/roomqr.png";
import qrdownload from "../../assets/svg/qrdownloads.svg";

import { Form, Button, Container, InputGroup } from "react-bootstrap";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Header from "../common/Header";
import LoaderModal from "../common/Loader.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export default function RoomsView() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const [meetingRoomDetails, setMeetingRoom] = useState({});

  const [selectedCategory, setCategoryValue] = useState("");
  const [selectedSlot, setSlotValue] = useState("30 mins");
  const [selectedBookId, setBookId] = useState([]);

  const [categoryList, setCategory] = useState([]);

  const [floorList, setFloors] = useState([]);
  const [roomDetails, setRoomDetails] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const closeModal = () => setIsOpen(false);
  const [selectedRoomId, setRoomId] = useState(-1);
  const [selectedRoomIndex, setRoomIndex] = useState(-1);
  const [availableList, setAvailable] = useState(["Ac", "Projector", "TV & Speaker"]);
  const [inviteEmails, setInviteEmail] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const menuBoxInactive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center" };
  const menuBoxActive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "3px solid #842234" };
  const menuColorActive = { fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#842234" };
  const menuColorInactive = { fontSize: "15px", fontWeight: "400", lineHeight: "17.17px", color: "#1E1E1E" };
  const profileName = { fontSize: "14px", fontWeight: "700", color: "#842234" };
  const title = { fontSize: "32px", fontWeight: "700", color: "#1E1E1E" };
  const subtitle = { fontSize: "15px", fontWeight: "400", color: "#81878C" };
  const roomTitle = { fontSize: "18px", fontWeight: "500", color: "#1E1E1E" };
  const seatCount = { fontSize: "13.5px", fontWeight: "400", color: "#81878C", marginTop: "8px" };
  const availableTitle = { fontSize: "12px", fontWeight: "400", color: "#81878C", marginBottom: "8px" };
  const availableName = { fontSize: "12.5px", fontWeight: "400", color: "#21272C" };
  const slotTitle = { fontSize: "13px", fontWeight: "700", color: "#1E1E1E" };
  const slotTitleSelected = { fontSize: "12px", fontWeight: "500", color: "#842234" };
  const filterTitle = { fontSize: "24px", fontWeight: "700", color: "#1E1E1E" };
  const officeTitle = { marginTop: "16px", marginBottom: "8px", fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#1E1E1E" };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 0.8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "328px",
      height: "229px",
      textAlign: "center",
    },
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiCall("get", `room/${id}`);
      console.log(response);
      if (response?.data?.success === true) {
        setRoomDetails(response.data.room);
        console.log("rooms");
        console.log(roomDetails);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="GTWalsheimTrial px-0">
      <Row className="flex-wrap px-3" style={{ height: "calc(100vh - 68px)", overflow: "auto", scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: "center", paddingBottom: "40px" }}>
        <Col xl={8} style={{ padding: "16px", justifyContent: "center" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "12px" }}>
            <div style={{ fontSize: "13px", fontWeight: "400", color: "#1e1e1e" }}>Master</div>
            <ArrowNextIcon />

            <div style={{ fontSize: "13px", fontWeight: "400", color: "#1e1e1e" }}>Rooms</div>
            <ArrowNextIcon />

            <div style={{ fontSize: "13px", fontWeight: "500", color: "#842234" }}>{roomDetails.name ?? ""}</div>
          </div>
          <div style={{ marginTop: "8px", marginBottom: "16px" }}>
            {!roomDetails.images || roomDetails.images.length === 0 ? (
              <img src={RoomImage} alt="room" style={{ width: "100%", height: "279px", objectFit: "cover", borderRadius: "8px" }} />
            ) : (
              <Slider {...settings}>
                {roomDetails.images.map((img, index) => (
                  <div key={index}>
                    <img src={img.url} alt={`Slide ${index}`} style={{ width: "100%", height: "279px", objectFit: "scale-down", borderRadius: "8px" }} />
                  </div>
                ))}
              </Slider>
            )}
          </div>

          <div style={{ padding: "16px", marginTop: "16px", borderRadius: "24px", background: "#ffffff" }}>
            <div style={{ borderRadius: "4px", padding: "4px 13px", backgroundColor: "#ffe9ed", maxWidth: "fit-content", fontWeight: "500", fontSize: "12px", color: "#842234", height: "22px", lineHeight: "100%" }}>#{roomDetails.code}</div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex" }}>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#1E1E1E" }}>{roomDetails.name}</div>

                  <div style={{ display: "flex", alignItems: "center", justifyContent: "start", marginBottom: "20px" }}>
                    <div style={{ fontSize: "14px", fontWeight: "500", color: "#842234" }}>{roomDetails.capacity} Seater</div> &nbsp;&nbsp; <div style={{ width: "3px", height: "3px", backgroundColor: "#D9D9D9" }}></div>&nbsp;&nbsp;
                    <div style={{ fontSize: "14px", fontWeight: "500", color: "#81878C" }}>{roomDetails.category}</div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#333" }}>Features :</div>
            <Col lg={8} style={{ display: "flex", flexWrap: "wrap" }}>
              {roomDetails?.features?.length > 0 &&
                roomDetails.features.map((feature, index) => (
                  <div key={`${index}-feature`} style={{ height: "24px", marginRight: "6px", marginBottom: "4px", paddingLeft: "8px", paddingRight: "8px", borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#F5F7F9" }}>
                    <div style={{ fontSize: "12px", color: "#000", fontWeight: "500" }}>{feature}</div>
                  </div>
                ))}
            </Col>
          </div>

          <div style={{ width: "100%" }}>
            <Row className="g-3 mt-3">
              <Col xs={12} lg={6}>
                <div style={{ borderRadius: "24px", padding: "16px", backgroundColor: "#ffffff", height: "180px" }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    <div style={{ fontWeight: "700", fontSize: "14px", color: "#1e1e1e" }}>Office details</div>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", borderRadius: "24px", padding: "16px", backgroundColor: "#fff0f3" }}>
                      <div>
                        <img src={office} style={{ width: "36px" }} />
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        <div style={{ fontWeight: "500", fontSize: "14px", color: "#1e1e1e" }}>{roomDetails.office}</div>
                        <div style={{ fontWeight: "400", fontSize: "12px", color: "#1e1e1e" }}>{roomDetails.floor_label}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} lg={6}>
                <div style={{ borderRadius: "24px", padding: "16px", backgroundColor: "#ffffff", height: "180px" }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    <div style={{ fontWeight: "700", fontSize: "14px", color: "#1e1e1e" }}>QR code</div>
                    <div style={{ display: "flex", alignItems: "center", gap: "60px", backgroundColor: "#ffffff", marginBottom: "30px" }}>
                      <div>
                        <img src={roomDetails.qr} style={{ width: "100px" }} alt="QR Code" />
                      </div>
                      <div
                        onClick={async () => {
                          try {
                            const response = await fetch(roomDetails.qr);
                            const blob = await response.blob();
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = "room-qr.png";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);
                          } catch (error) {
                            console.error("Download failed", error);
                          }
                        }}
                        style={{ height: "36px", borderRadius: "6px", border: "1px solid #e5e5e5", backgroundColor: "#ffffff", display: "flex", alignItems: "center", gap: "12px", padding: "12px 16px", cursor: "pointer" }}>
                        <div>
                          <img src={qrdownload} alt="Download Icon" />
                        </div>
                        <div style={{ fontWeight: "500", fontSize: "12px", color: "#842234" }}>Download as PNG</div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <LoaderModal show={loading} />
    </Container>
  );
}
